import { Option } from '../category/category.types';

export enum DiscountType {
  Compensation = 'compensation',
  EmployeeDiscount = 'employee_discount',
  OpenPercentage = 'open_percentage',
  OpenDollar = 'open_dollar',
  FixedPercentage = 'fixed_percentage',
  FixedDollar = 'fixed_dollar',
}

export enum DiscountConfigurationType {
  FIXED_AMOUNT = 'fixed_amount',
  FIXED_PERCENTAGE = 'fixed_percentage',
  OPEN_AMOUNT = 'open_amount',
  OPEN_PERCENTAGE = 'open_percentage',
  DEFAULT_VALUE = '',
}

export enum DiscountConfigurationApplicationScope {
  ENTIRE_CHECK = 'entire_check',
  MENU = 'menu',
}

export interface DiscountRequestType {
  name: string;
  type: string;
  value: number;
}

export interface DiscountResponseType {
  ticketId?: string;
  discountId?: string;
  value?: number;
}

export enum AIOPlatformType {
  POS = 'pos',
  ONLINE = 'online',
}

export enum DiscountStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export enum PermissionLevelType {
  ANYUSER = 'Anyuser',
  MANAGER = 'Manager',
}

export interface IDiscountFormData {
  menus: IDiscountFormMenu[];
  categories: IDiscountFormCategory[];
  items: Option[];
}

export interface IDiscountFormCategory {
  items: number[];
  label: string;
  value: number;
}

export interface IDiscountFormMenu {
  label: string;
  value: number;
  categories: number[];
  items: number[];
}

export interface IMenuDiscount {
  hasMenu: boolean;
  hasCategory: boolean;
  hasItem: boolean;
  menus?: Option[];
  categories?: Option[];
  items?: Option[];
}

export interface IEntireDiscount {
  isDiscountNotApplied: boolean;
  exceptionCategories: Option[];
  exceptionItems: Option[];
  isIncluded: boolean;
  isExcluded: boolean;
  inclusionCategories: Option[];
  inclusionItems: Option[];
}

export enum DiscountConfigurationApplicationInclusionType {
  MENU = 'Menu',
  CATEGORY = 'Category',
  ITEM = 'Item',
}

export enum DiscountDateType {
  SINGLE_DAY = 'single_day',
  DATE_RANGE = 'date_range',
  NO_END_DATE = 'no_end_date',
}
